import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

interface Props {
  focused: boolean;
}

const RailsContainer = styled.div<Props>`
  margin-left: ${96 * Screen.widthRatio}px;
  pointer-events: none;
  top: ${544 * Screen.widthRatio}px;
  position: absolute;
  width: max-content;
  z-index: ${(props) => (props.focused ? 0 : 1)};
`;

export default withAnimation(RailsContainer);
